import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM3.6 24C3.6 35.2666 12.7334 44.4 24 44.4C35.2666 44.4 44.4 35.2666 44.4 24C44.4 12.7334 35.2666 3.6 24 3.6C12.7334 3.6 3.6 12.7334 3.6 24Z",
      fill: "#F2F2F2",
      id: "progress-circle"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0ZM24 44.4C35.2666 44.4 44.4 35.2666 44.4 24C44.4 12.7334 35.2666 3.6 24 3.6C12.7334 3.6 3.6 12.7334 3.6 24C3.6 35.2666 12.7334 44.4 24 44.4Z",
      fill: "#439f7f"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.1699 22.0273C14.1699 20.25 15.5986 18.9512 17.5605 18.9512C19.4404 18.9512 20.8418 20.1475 20.8418 21.7129C20.8418 22.8613 20.2266 23.7158 18.7842 25.1924L16.3164 27.6738V27.708H20.999V29H14.252V27.9609L17.8135 24.3311C19.0166 23.0801 19.3311 22.5605 19.3311 21.7881C19.3311 20.9131 18.5381 20.2158 17.5127 20.2158C16.4326 20.2158 15.6191 20.9951 15.6191 22.0205V22.041H14.1699V22.0273ZM22.9062 31.1055H21.5938L25.0938 19.1357H26.4062L22.9062 31.1055ZM27.0898 22.0273C27.0898 20.25 28.5186 18.9512 30.4805 18.9512C32.3604 18.9512 33.7617 20.1475 33.7617 21.7129C33.7617 22.8613 33.1465 23.7158 31.7041 25.1924L29.2363 27.6738V27.708H33.9189V29H27.1719V27.9609L30.7334 24.3311C31.9365 23.0801 32.251 22.5605 32.251 21.7881C32.251 20.9131 31.458 20.2158 30.4326 20.2158C29.3525 20.2158 28.5391 20.9951 28.5391 22.0205V22.041H27.0898V22.0273Z",
      fill: "#1C2026",
      id: "progress-digits"
    }, null, -1)
  ])))
}
export default { render: render }